export const mainColors = Object.freeze({
  black: "#0d0d0d",
  white: "#ffffff",
  red: "#EE4D37",
  yellow: "#F08D32",
  blue: "#144CC7",
  green: "#06C270",
});

export const colorPalette = Object.freeze({
  // Semantic color palettes - 100 to 1000 shades
  slate: {
    100: "#f6f6f6",
    200: "#e3e3e3",
    300: "#cdcdcd",
    400: "#b2b2b2",
    500: "#949494",
    600: "#767676",
    700: "#5a5a5a",
    800: "#434343",
    900: "#303030",
    1000: "#242424",
  },
  gray: {
    100: "#ffffff",
    200: "#fbfbfb",
    300: "#efefef",
    400: "#e0e0e0",
    500: "#d2d2d2",
    600: "#8a8a8a",
    700: "#3d3d3d",
    800: "#161616",
    900: "#121212",
    1000: "#0d0d0d",
  },
  white: {
    100: "#D2D2D2",
    200: "#E0E0E0",
    300: "#EFEFEF",
    400: "#FBFBFB",
    500: "#ffffff",
    600: "#ffffff",
    700: "#ffffff",
    800: "#ffffff",
    900: "#ffffff",
    1000: "#ffffff",
  },
  black: {
    100: "#8A8A8A",
    200: "#3D3D3D",
    300: "#161616",
    400: "#121212",
    500: "#0D0D0D",
    600: "#0d0d0d",
    700: "#0d0d0d",
    800: "#0d0d0d",
    900: "#0d0d0d",
    1000: "#0d0d0d",
  },
  wishlink: {
    100: "#fce2dd",
    200: "#f6a69b",
    300: "#f47564",
    400: "#f05e4b",
    500: "#ee4d37",
    600: "#d64532",
    700: "#be3e2c",
    800: "#a73627",
    900: "#8f2e21",
    1000: "#77271c",
  },
  "wishlink-legacy": {
    100: "#fdf8ed",
    200: "#f9eacc",
    300: "#f3d294",
    400: "#edb65c",
    500: "#e99d36",
    600: "#e28126",
    700: "#c75d18",
    800: "#a54118",
    900: "#873319",
    1000: "#45110a",
  },
  red: {
    100: "#f2d9d9",
    200: "#e5b2b4",
    300: "#d78c8e",
    400: "#ca6569",
    500: "#bd3f43",
    600: "#aa393c",
    700: "#973236",
    800: "#842c2f",
    900: "#712628",
    1000: "#5f2022",
  },
  yellow: {
    100: "#fffbd6",
    200: "#fff7ae",
    300: "#fff066",
    400: "#ffeb34",
    500: "#ffeb34",
    600: "#e5d32f",
    700: "#ccbc2a",
    800: "#b2a424",
    900: "#998d1f",
    1000: "#80761a",
  },
  green: {
    100: "#e6f9f1",
    200: "#83e0b8",
    300: "#4fe3a3",
    400: "#1fc87f",
    500: "#06c270",
    600: "#05af65",
    700: "#059b5a",
    800: "#04884e",
    900: "#047443",
    1000: "#036138",
  },
  blue: {
    100: "#c2d0f2",
    200: "#89a5e3",
    300: "#3f6fd9",
    400: "#2c5ecd",
    500: "#144cc7",
    600: "#1244b3",
    700: "#103d9f",
    800: "#0e358b",
    900: "#0c2e77",
    1000: "#0a2664",
  },
  // Legacy palettes for backward compatibility
  popWhite: {
    100: "#D2D2D2",
    200: "#E0E0E0",
    300: "#EFEFEF",
    400: "#FBFBFB",
    500: "#ffffff",
    600: "#F6F3FF",
    700: "#EFF6FF",
  },
  popBlack: {
    100: "#8A8A8A",
    200: "#3D3D3D",
    300: "#161616",
    400: "#121212",
    500: "#0d0d0d",
  },
  poliPurple: {
    100: "#E8DFFF",
    200: "#D2C2FF",
    900: "#DDB6FC",
    300: "#B49AFF",
    400: "#9772FF",
    500: "#6A35FF",
    600: "#4A25B3",
    700: "#351A80",
    800: "#20104D",
    950: "#FEF3FF",
  },
  orangeSunshine: {
    100: "#FFEFE6",
    200: "#FFDBC7",
    300: "#FFC3A2",
    400: "#FFAB7C",
    500: "#FF8744",
    600: "#B35F30",
    700: "#804322",
    800: "#4D2914",
    900: "#FC913D",
    950: "#FFE4D0",
  },
  parkGreen: {
    100: "#DDFFF1",
    200: "#C4FFE6",
    300: "#9DFFD6",
    400: "#76FFC6",
    500: "#3BFFAD",
    600: "#29B379",
    700: "#1E8057",
    800: "#124D34",
    900: "#6CB973",
  },
  pinkPong: {
    100: "#FFE1E9",
    200: "#FFC6D4",
    300: "#FFA0B7",
    400: "#FF7B9A",
    500: "#FF426F",
    600: "#B32E4E",
    700: "#802138",
    800: "#4D1421",
  },
  mannna: {
    100: "#FFF8E5",
    200: "#FFEFC7",
    300: "#FFE5A2",
    400: "#FFDB7D",
    500: "#FFCB45",
    600: "#B38E30",
    700: "#806623",
    800: "#4D3D15",
  },
  neoPaccha: {
    100: "#FBFFE6",
    200: "#F7FFC6",
    300: "#F7FFC6",
    400: "#EDFE79",
    500: "#E5FE40",
    600: "#A0B22D",
    700: "#727F20",
    800: "#454C13",
    900: "#C8E565",
    950: "#E3FFE6",
  },
  yoyo: {
    100: "#F4E5FF",
    200: "#E5C5FF",
    300: "#D59FFF",
    400: "#C379FF",
    500: "#AA3FFF",
    600: "#772CB3",
    700: "#552080",
    800: "#33134D",
  },
  // Legacy state colors (kept for backward compatibility)
  error: {
    100: "#F2D9D9",
    200: "#E5B2B4",
    300: "#D78C8E",
    400: "#CA6569",
    500: "#BD3F43",
  },
  warning: {
    100: "#FFFBD6",
    200: "#FFF7AE",
    300: "#FFF066",
    400: "#FFEB34",
    500: "#FFEB34",
  },
  info: {
    100: "#C2D0F2",
    200: "#89A5E3",
    300: "#3F6FD9",
    400: "#2C5ECD",
    500: "#144CC7",
    600: "#A1CAFF",
  },
  success: {
    100: "#E6F9F1",
    200: "#83E0B8",
    300: "#4FE3A3",
    400: "#1FC87F",
    500: "#06C270",
  },
  popOrange: {
    100: "#FCE2DD",
    200: "#F6A69B",
    300: "#F47564",
    400: "#F05E4B",
    500: "#EE4D37",
  },
});

// dark theme is not is use yet
const getDarkThemedColors = () => ({
  font: {
    heading: mainColors.black,
    subHeading: mainColors.black,
    bodyText: mainColors.black,
    bodyTextLighter: mainColors.black,
  },
  containerCard: {
    background: colorPalette.black[100],
    stroke: "rgba(255,255,255,0.1)",
  },
  toast: {
    success: {
      background: mainColors.green,
      color: "#F8F8F8",
    },
    warning: {
      background: mainColors.yellow,
      color: "#F8F8F8",
    },
    error: {
      background: mainColors.red,
      color: "#F8F8F8",
    },
  },
  dropdown: {
    withLabel: {
      // text: hexToRGBA(mainColors.black, 0.5),
      // border: hexToRGBA(mainColors.black, 0.1),
      // chevron: hexToRGBA(mainColors.black, 0.5),
    },
    withoutLabel: {
      // text: hexToRGBA(mainColors.black, 0.5),
      border: mainColors.black,
      chevron: mainColors.black,
    },
  },
  scoremeter: {
    meterStrokeColor: {
      excellent: mainColors.green,
      average: colorPalette.neoPaccha[400],
      poor: colorPalette.warning[400],
    },
    meterStrokeBackground: "transparent",
    meterBorderColor: colorPalette.popWhite[200],
    dotColor: colorPalette.popBlack[300],
    indicatorColors: {
      neutral: "#e2e2e2",
      increment: "#5CDDBE",
      decrement: "#FFB098",
    },
    scoreContainerBackground: colorPalette.popWhite[300],
    scoreContainerBorder: colorPalette.popWhite[400],
    scoreColor: mainColors.black,
  },
  tags: {
    warning: {
      background: "#FEF4EB",
      color: mainColors.yellow,
    },
    error: {
      background: "#FDEDEB",
      color: mainColors.red,
    },
    success: {
      background: "#E6F9F1",
      color: mainColors.green,
    },
    info: {
      background: "#EBF1FE",
      color: mainColors.blue,
    },
  },
  checkbox: {
    background: mainColors.white,
    border: mainColors.black,
    leftPlunk: colorPalette.black[500],
    topPlunk: colorPalette.white[500],
  },
  inputFields: {
    textColor: mainColors.black,
    labelColor: mainColors.black,
    caretColor: mainColors.blue,
    errorColor: mainColors.red,
    // placeholderColor: hexToRGBA(mainColors.black, 0.3),
  },
  buttons: {
    primary: {
      backgroundColor: mainColors.white,
      color: mainColors.black,
      edgeColors: {
        bottom: colorPalette.black[500],
        right: colorPalette.white[500],
        top: colorPalette.popBlack[200],
        left: colorPalette.popBlack[100],
      },
      disabledColors: {
        backgroundColor: colorPalette.popBlack[100],
        // color: hexToRGBA(mainColors.white, 0.5),
        edgeColors: {
          top: "transparent",
          left: "transparent",
          right: "#B6B6B6",
          bottom: colorPalette.popBlack[200],
        },
      },
    },
    secondary: {
      backgroundColor: mainColors.black,
      color: mainColors.white,
      borderColor: mainColors.white,
      edgeColors: {
        bottom: colorPalette.black[500],
        top: "#262626",
        right: colorPalette.white[500],
        left: "#404040",
      },
      disabledColors: {
        backgroundColor: mainColors.black,
        color: mainColors.white,
        borderColor: mainColors.white,
        edgeColors: {
          top: "transparent",
          left: "transparent",
          right: "transparent",
          bottom: "transparent",
        },
      },
    },
  },
});

const getLightThemedColors = () => ({
  font: {
    heading: mainColors.black,
    subHeading: mainColors.black,
    bodyText: mainColors.black,
    bodyTextLighter: mainColors.black,
  },
  containerCard: {
    background: colorPalette.black[100],
    stroke: "rgba(255,255,255,0.1)",
  },
  toast: {
    success: {
      background: mainColors.green,
      color: "#F8F8F8",
    },
    warning: {
      background: mainColors.yellow,
      color: "#F8F8F8",
    },
    error: {
      background: mainColors.red,
      color: "#F8F8F8",
    },
  },
  dropdown: {
    withLabel: {
      // text: hexToRGBA(mainColors.black, 0.5),
      // border: hexToRGBA(mainColors.black, 0.1),
      // chevron: hexToRGBA(mainColors.black, 0.5),
    },
    withoutLabel: {
      // text: hexToRGBA(mainColors.black, 0.5),
      border: mainColors.black,
      chevron: mainColors.black,
    },
  },
  scoremeter: {
    meterStrokeColor: {
      excellent: mainColors.green,
      average: colorPalette.neoPaccha[400],
      poor: colorPalette.warning[400],
    },
    meterStrokeBackground: "transparent",
    meterBorderColor: colorPalette.popWhite[200],
    dotColor: colorPalette.popBlack[300],
    indicatorColors: {
      neutral: "#e2e2e2",
      increment: "#5CDDBE",
      decrement: "#FFB098",
    },
    scoreContainerBackground: colorPalette.popWhite[300],
    scoreContainerBorder: colorPalette.popWhite[400],
    scoreColor: mainColors.black,
  },
  tags: {
    warning: {
      background: "#FEF4EB",
      color: mainColors.yellow,
    },
    error: {
      background: "#FDEDEB",
      color: mainColors.red,
    },
    success: {
      background: "#E6F9F1",
      color: mainColors.green,
    },
    info: {
      background: "#EBF1FE",
      color: mainColors.blue,
    },
  },
  checkbox: {
    color: colorPalette.white[500],
    background: colorPalette.success[500],
    border: colorPalette.popBlack[500],
    disabled: {
      background: colorPalette.success[200],
      border: colorPalette.popBlack[200],
    },
  },
  radioButton: {
    selected: {
      background: colorPalette.success[500],
      border: colorPalette.success[500],
    },
    unselected: {
      border: colorPalette.popBlack[500],
    },
    disabled: {
      selected: {
        background: colorPalette.success[200],
        border: colorPalette.success[200],
      },
      unselected: {
        border: colorPalette.popBlack[200],
      },
    },
    postType: {
      selected: {
        border: colorPalette.success[500],
      },
      unselected: {
        border: colorPalette.popWhite[500],
      },
    },
  },
  topNav: {
    background: colorPalette.white[500],
    iconColor: colorPalette.popBlack[500],
    supportIconColor: colorPalette.popBlack[200],
  },
  accordion: {
    background: colorPalette.white[500],
    color: colorPalette.popBlack[500],
    disabledColors: {
      backgroundColor: "#CFD0D4",
    },
    accordionDetailBackground: "#D9D9D9",
    accordionLineColor: "#cfd0d4",
  },
  progressBar: {
    backgroundColor: colorPalette.popOrange[500],
    color: colorPalette.popBlack[500],
  },
  stepper: {
    stepBackground: colorPalette.popOrange[500],
    descriptionColor: mainColors.blue,
  },
  inputFields: {
    textColor: mainColors.black,
    labelColor: mainColors.black,
    caretColor: mainColors.blue,
    errorColor: mainColors.red,
    // placeholderColor: hexToRGBA(mainColors.black, 0.3),
  },
  buttons: {
    primary: {
      backgroundColor: colorPalette.popOrange[500],
      color: colorPalette.popWhite[500],
      disabledColors: {
        backgroundColor: colorPalette.popBlack[100],
        color: colorPalette.popWhite[200],
      },
    },
    secondary: {
      backgroundColor: colorPalette.popWhite[500],
      color: colorPalette.popOrange[500],
      borderColor: colorPalette.popOrange[500],
      disabledColors: {
        backgroundColor: colorPalette.popBlack[100],
        color: colorPalette.popWhite[200],
        borderColor: colorPalette.popBlack[200],
      },
    },
    danger: {
      backgroundColor: colorPalette.error[200],
      color: colorPalette.error[500],
      disabledColors: {
        backgroundColor: colorPalette.error[200],
        color: colorPalette.error[500],
        borderColor: colorPalette.error[500],
      },
    },
  },
  actionButton: {
    primary: {
      backgroundColor: colorPalette.popOrange[100],
      color: colorPalette.popOrange[500],
      disabledColors: {
        backgroundColor: colorPalette.popWhite[100],
        color: colorPalette.popWhite[500],
        outlineColor: colorPalette.popBlack[100],
      },
      outlineColor: colorPalette.popOrange[500],
    },
    secondary: {
      backgroundColor: "transparent",
      color: colorPalette.popOrange[500],
      disabledColors: {
        backgroundColor: "transparent",
        color: colorPalette.popBlack[200],
        outlineColor: colorPalette.popBlack[200],
      },
      outlineColor: colorPalette.popOrange[500],
    },
    info: {
      backgroundColor: "transparent",
      color: colorPalette.info[500],
      disabledColors: {
        backgroundColor: "transparent",
        color: colorPalette.popBlack[200],
        outlineColor: colorPalette.popBlack[200],
      },
      outlineColor: colorPalette.info[500],
    },
    danger: {
      backgroundColor: colorPalette.error[200],
      color: colorPalette.error[500],
      disabledColors: {
        backgroundColor: colorPalette.popBlack[100],
        color: colorPalette.popWhite[200],
        outlineColor: colorPalette.popWhite[200],
      },
      outlineColor: colorPalette.error[500],
    },
  },
  socialButton: {
    color: colorPalette.popWhite[500],
  },
  OTPInputField: {
    default: {
      backgroundColor: colorPalette.popWhite[500],
      border: colorPalette.popWhite[300],
      inputBorder: colorPalette.popWhite[100],
    },
    success: {
      backgroundColor: colorPalette.success[100],
      border: colorPalette.success[300],
      inputBorder: colorPalette.success[500],
    },
    error: {
      backgroundColor: colorPalette.error[100],
      border: colorPalette.error[300],
      inputBorder: colorPalette.error[500],
    },
  },
  spacing: {
    background: colorPalette.popWhite[500],
  },
  pill: {
    selected: {
      background: colorPalette.info[200],
      border: colorPalette.info[500],
    },
    unSelected: {
      background: colorPalette.popWhite[500],
      border: colorPalette.popWhite[100],
    },
  },
  customDatePicker: {
    background: colorPalette.popOrange[100],
    color: colorPalette.popBlack[100],
    selected: {
      color: "#0E1226",
    },
  },
  actionCard: {
    background: colorPalette.white[400],
    iconColor: colorPalette.popBlack[500],
  },
  filterChips: {
    selected: {
      border: colorPalette.popOrange[500],
      background: colorPalette.popOrange[500],
      color: colorPalette.popWhite[500],
    },
    unSelected: {
      border: colorPalette.popWhite[200],
      background: colorPalette.popWhite[500],
      color: colorPalette.popBlack[500],
    },
  },
  pills: {
    default: {
      selected: {
        background: colorPalette.info[200],
        border: colorPalette.info[500],
      },
      unSelected: {
        background: colorPalette.popWhite[500],
        border: colorPalette.popWhite[100],
      },
    },
    primary: {
      selected: {
        background: colorPalette.popOrange[500],
        border: colorPalette.popOrange[500],
      },
      unSelected: {
        background: colorPalette.popWhite[500],
        border: colorPalette.popWhite[100],
      },
    },
    tag: {
      selected: {
        background: colorPalette.popOrange[500],
        border: colorPalette.popOrange[500],
        iconColor: colorPalette.popWhite[500],
      },
      unSelected: {
        background: colorPalette.popWhite[500],
        border: colorPalette.popWhite[100],
      },
    },
    label: {
      selected: {
        background: colorPalette.popOrange[500],
        border: colorPalette.popOrange[500],
        iconColor: colorPalette.popWhite[500],
      },
      unSelected: {
        background: colorPalette.popWhite[500],
        border: colorPalette.popWhite[100],
      },
    },
  },
  shopCard: {
    refresh: {
      iconBackground: colorPalette.popBlack[100],
      iconColor: colorPalette.popWhite[500],
    },
    hidden: {
      iconBackground: colorPalette.error[100],
      iconColor: colorPalette.error[500],
    },
  },
  swipeableTabs: {
    color: "#6C6C6C",
    inkBarColor: "#DF472C",
    badgeColor: "#DF472C",
    badgeTextColor: "#FFFFFF",
    disabled: {
      color: "#B0B0B0",
    },
    active: {
      color: "#DF472C",
    },
  },
  toastMessage: {
    iconColor: colorPalette.popWhite[500],
    buttonColor: colorPalette.popWhite[500],
    neutral: {
      buttonColor: colorPalette.popWhite[500],
      backgroundColor: colorPalette.popBlack[200],
      textColor: colorPalette.popWhite[500],
    },
    negative: {
      backgroundColor: colorPalette.error[500],
      textColor: colorPalette.popWhite[500],
    },
    positive: {
      backgroundColor: colorPalette.success[500],
      textColor: colorPalette.popWhite[500],
    },
  },
  toggleButton: {
    checked: {
      enabled: {
        backgroundColor: colorPalette.success[500],
        toggleBackgroundColor: colorPalette.popWhite[500],
      },
      disabled: {
        backgroundColor: colorPalette.popBlack[100],
        toggleBackgroundColor: colorPalette.popWhite[100],
      },
    },
    unchecked: {
      enabled: {
        backgroundColor: colorPalette.popWhite[300],
        toggleBackgroundColor: colorPalette.popWhite[500],
      },
      disabled: {
        backgroundColor: colorPalette.popWhite[100],
        toggleBackgroundColor: colorPalette.popWhite[300],
      },
    },
  },
  searchInput: {
    borderColor: colorPalette.popOrange[200],
    iconColor: colorPalette.popBlack[200],
    color: colorPalette.popBlack[500],
    focused: {
      borderColor: colorPalette.popOrange[500],
      iconColor: colorPalette.popOrange[500],
    },
  },
  brandCard: {
    saleTagColor: colorPalette.mannna[400],
    upto: {
      backgroundColor: colorPalette.popOrange[100],
      color: colorPalette.popOrange[500],
    },
    flat: {
      backgroundColor: colorPalette.info[100],
      color: colorPalette.info[500],
    },
  },
  banner: {
    backgroundColor: "#FF84FF",
    textColor: colorPalette.popWhite[500],
  },
  brandLedger: {
    backgroundColor: colorPalette.popWhite[500],
    borderColor: colorPalette.popWhite[100],
    imageBackgroundColor: "#FFDBC7",
    adjustmentIconColor: colorPalette.info[500],
  },
  commissionCard: {
    bgColor: "#F5F5F5",
    pending: {
      bgColor: colorPalette.popOrange[100],
      iconColor: colorPalette.error[500],
      tagTextColor: colorPalette.popBlack[500],
      tagBgColor: colorPalette.popWhite[500],
    },
    confirmed: {
      bgColor: colorPalette.success[100],
      iconColor: colorPalette.success[500],
      tagTextColor: colorPalette.popBlack[500],
      tagBgColor: colorPalette.popWhite[500],
    },
  },
  commissionPageCard: {
    iconColor: colorPalette.popBlack[500],
    adjustmentIconColor: colorPalette.info[500],
    pending: {
      iconColor: colorPalette.popWhite[500],
      tagTextColor: colorPalette.popWhite[500],
      tagBgColor: colorPalette.error[400],
    },
    confirmed: {
      iconColor: colorPalette.popWhite[500],
      tagTextColor: colorPalette.popWhite[500],
      tagBgColor: colorPalette.success[500],
    },
  },
  ledger: {
    bgColor: colorPalette.popWhite[400],
    iconColor: colorPalette.error[500],
    noteColor: colorPalette.info[300],
    tagIconColor: colorPalette.popOrange[500],
    tagTextColor: colorPalette.popBlack[500],
    tagBgColor: colorPalette.popOrange[100],
  },
  orderAccordion: {
    bgColor: colorPalette.warning[200],
    borderColor: colorPalette.popWhite[100],
    headerColor: colorPalette.popBlack[500],
    accordionLineColor: "#cfd0d4",
  },
  orderLedger: {
    bgColor: colorPalette.popWhite[500],
    borderColor: colorPalette.popWhite[100],
    iconColor: colorPalette.info[500],
  },
  pastPayoutCard: {
    bgColor: "#F7FFC6",
    commission: {
      bgColor: colorPalette.popWhite[400],
    },
  },
  toolTip: {
    bgColor: colorPalette.popBlack[500],
  },
  secondaryTab: {
    bgColor: colorPalette.popWhite[400],
    tabItem: {
      bgColor: colorPalette.popWhite[400],
      color: "#6C6C6C",
      active: {
        bgColor: colorPalette.popOrange[300],
        color: colorPalette.popWhite[500],
      },
    },
  },
  icon: {
    borderColor: colorPalette.popWhite[500],
  },
});

const getColorGuide = () => ({
  mainAppBackground: mainColors.white,
  darkComponents: getDarkThemedColors(),
  lightComponents: getLightThemedColors(),
});

export const colorGuide = getColorGuide();
